export type CommentCounts = {
  unreplied: number
  replied: number
  dismissed: number
}

export function getProgressColor(
  percentage: number,
): 'critical' | 'warning' | 'success' {
  if (percentage >= 60) return 'success'
  if (percentage >= 30) return 'warning'
  return 'critical'
}

function getDecimalSeparator(): string {
  const parts = new Intl.NumberFormat(undefined, {
    maximumFractionDigits: 1,
  }).formatToParts(1.1)
  const decimalPart = parts.find((p) => p.type === 'decimal')
  return decimalPart?.value ?? '.'
}

export function formatCompactCount(count: number): string {
  if (count >= 10_000) return `${Math.round(count / 1000)}K`
  if (count >= 1_000) {
    const value = (count / 1000).toFixed(1).replace(/\.0$/, '')
    const withLocaleDecimal = value.replace('.', getDecimalSeparator())
    return `${withLocaleDecimal}K`
  }
  return String(count)
}

/**
 * Formats interacted/total pair. When total is in thousands, shows interacted
 * in full and total abbreviated. Uses user locale (e.g. "1,270 / 1,7K" with comma decimal).
 */
export function formatCompactCountPair(
  interacted: number,
  total: number,
): [string, string] {
  if (total >= 1_000) {
    const interactedFormatted =
      interacted >= 1_000
        ? interacted.toLocaleString(undefined)
        : String(interacted)
    return [interactedFormatted, formatCompactCount(total)]
  }

  return [String(interacted), String(total)]
}

export function formatUnrepliedCount(count: number): string {
  return count > 99 ? '99+' : String(count)
}
